import OffClickDirective from './off-click.directive';
import LogoDirective from './logo.directive';
import LangDirective from './lang.directive';
import SliderDirective from './slider.directive';
import setUpConstants from './constants';

let commonsModule = angular.module('commons', []);
commonsModule.directive('offClick', OffClickDirective);
commonsModule.directive('logo', LogoDirective);
commonsModule.directive('slider', SliderDirective);
commonsModule.directive('lang', LangDirective);
setUpConstants(commonsModule);

export default commonsModule = commonsModule.name



// WEBPACK FOOTER //
// ./src/commons/commons.module.js